// @ts-check
import React, { useLayoutEffect, useRef, useState } from "react"
import { clsx } from "../../../../../utils/strings.utils"

/**
 * @typedef {object} MessageBubbleProps
 * @property {import("react").ReactNode} children
 * @property {string} [className]
 * @property {number} [collapsibleMaxPx] cuando el contenido supera esta altura, muestra Mostrar más/menos
 */

/**
 * @param {MessageBubbleProps} props
 */
export default function MessageBubble({
  children,
  className,
  collapsibleMaxPx,
}) {
  const innerRef = useRef(/** @type {HTMLDivElement | null} */ (null))
  const [expanded, setExpanded] = useState(false)
  const [needsCollapse, setNeedsCollapse] = useState(false)

  const collapsible =
    typeof collapsibleMaxPx === "number" && collapsibleMaxPx > 0

  useLayoutEffect(() => {
    if (!collapsible) {
      setNeedsCollapse(false)
      return
    }
    const el = innerRef.current
    if (!el) return
    const full = el.scrollHeight
    const over = full > /** @type {number} */ (collapsibleMaxPx)
    setNeedsCollapse(over)
    if (!over) setExpanded(false)
  }, [children, collapsible, collapsibleMaxPx])

  if (!collapsible) {
    return (
      <div className={clsx("estimation-agent-quick-v3__bubble", className)}>
        {children}
      </div>
    )
  }

  const showToggle = needsCollapse

  return (
    <div className={clsx("estimation-agent-quick-v3__bubble", className)}>
      <div
        ref={innerRef}
        className="estimation-agent-quick-v3__bubble-body"
        style={
          showToggle && !expanded ?
            {
              maxHeight: collapsibleMaxPx,
              overflow: "hidden",
            }
          : undefined
        }
      >
        {children}
      </div>
      {showToggle ?
        <button
          type="button"
          className="estimation-agent-quick-v3__bubble-expand"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
        >
          <span>
            {expanded ? "Mostrar menos" : "Mostrar más"}
          </span>
          <i
            className={clsx(
              "pi",
              expanded ? "pi-chevron-up" : "pi-chevron-down"
            )}
            aria-hidden
          />
        </button>
      : null}
    </div>
  )
}
